import { commonUtils } from '@/helpers/commonUtils'
import PdfPage, { PageHeader, useMarkdownFontSize } from '../PdfPage/PdfPage'
import styles from './PdfPageMomentSuggestions.module.less'
import MarkdownRenderer from '@/components/MarkdownRenderer/MarkdownRenderer'
import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
  suggestions: string
  onRendered: () => void
  project: ProjectModels.ProjectDetail
  no: number
}

function PdfPageMomentSuggestions(props: Props) {
  const BOX_MAX_HEIGHT = 690
  const summaryRef = useRef<HTMLDivElement>(null)
  const { fontsize, end } = useMarkdownFontSize(summaryRef, BOX_MAX_HEIGHT)

  const { t } = useTranslation()
  useEffect(() => {
    if (end) {
      props.onRendered()
    }
  }, [end])

  return (
    <PdfPage bgSrc={commonUtils.getImagePath('PDFDownload/pdf-page-7/PDF-bg.jpg')} no={props.no}>
      <div className={styles.pdfPageMomentSuggestions}>
        <PageHeader
          project={props.project}
          text={'03.' + t('dashboard.projectDetailPage.detailAnalysis')}
        />

        <div className={styles.content}>
          <div className={styles.left}>
            <p className={styles.title}>
              <img
                className={styles.icon}
                src={commonUtils.getImagePath('PDFDownload/pdf-page-10/page10-icon.png')}
              />
              <span>{t('dashboard.projectDetailPage.storyboardView.suggestions')}</span>
            </p>

            <div className={styles.summary} ref={summaryRef}>
              <MarkdownRenderer style={{ fontSize: fontsize }} markdownText={props.suggestions} />
            </div>
          </div>

          <div className={styles.right}>
            <img
              className={styles.img}
              src={commonUtils.getImagePath('PDFDownload/pdf-page-10/right-img.jpg')}
            />
          </div>
        </div>
      </div>
    </PdfPage>
  )
}

export default PdfPageMomentSuggestions
